import { ContentEditor } from '../content/ContentEditor';

/**
 * Thin wrapper that drops the existing ContentEditor into the App
 * Settings card chrome. ContentEditor edits app-level externalized
 * content (the `external_content` table) — strings, copy, etc. that
 * authors override per-app without touching the view tree. That's
 * always been an app-level concept, so it lives here in App Settings
 * instead of polluting the View Builder right rail.
 *
 * No styling overrides — ContentEditor brings its own internal layout.
 */
export function ContentSection({ appId }: { appId: string }) {
  return <ContentEditor appId={appId} />;
}
